import { render, staticRenderFns } from "./bin-create.vue?vue&type=template&id=0ff65b2c&"
import script from "./bin-create.vue?vue&type=script&lang=js&"
export * from "./bin-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports